'use strict';

import {getSelectedRowData, subLangPlaceHolder} from "../jquery-functions-library";
import {element_exists} from "../functions";
import {uploadMoreVouchers} from "./upload-pdf";

export var fnUploadSelectedVouchers = function () {


    var tableName = '#datatable-vouchers';

    if (!element_exists(tableName)) return false;

    var lang = allLangFiles.vouchers.select.upload;

    var btnUpload = $('#btn-upload-selected-vouchers');

    btnUpload.off('click').on('click', function (e) {

        $(this).parent().parent('.dropdown.open').removeClass('open');

        var dataTable = $(tableName).DataTable();
        var selectedRowData = getSelectedRowData(dataTable);

        var formData = [];

        var texts = [];
        var invalidSelections = [];

        console.log(selectedRowData.length);

        $.each(selectedRowData, function (index, voucher) {

            /*Only not uploaded*/
            if (!voucher.uploaded && (voucher.has_voucher || voucher.is_valid_no_file)) {
                formData.push(voucher.id);
                texts.push('#' + voucher.VoucherNumber);
            }
            /*reset and return if any selections have been uploaded*/
            else {
                invalidSelections.push('#' + voucher.VoucherNumber);
            }
        });


        if (invalidSelections.length) {
            toastr.warning(
                subLangPlaceHolder(lang.invalid, ':body', '<br>' + invalidSelections.join(',') + '<br>')
            );
            formData = [];
            return false;
        }

        if (formData.length) {

            var content = subLangPlaceHolder(lang.content+' '+lang.description, ':body', '<br>' + texts.join(',') + '<br>');

            var selectedRows = tableName + ' tr.selected .btn-table-cell.btn-approve';

            uploadMoreVouchers('/voucher/upload/selection', {ids: formData}, selectedRowData, lang.title, content, selectedRows);
        }
    });
};